import { formatNumber as kitchenFormatNumber } from '@thefarmersfront/kitchen-utensil';

/**
 * 숫자에 천 단위로 콤마(,)를 찍고 단위를 붙여 반환하는 함수
 * @param num - 변환할 숫자
 * @param unit - 숫자 뒤에 붙일 단위
 * @example formatNumber(1234567,'원') => '1,234,567원'
 */
const formatNumber = (num: number, unit = ''): string => {
  const result = kitchenFormatNumber(num, {
    unit,
    fallback: '-',
    maximumFractionDigits: 15,
  });

  return result ?? '-';
};

export default formatNumber;
